export interface AiSettings {
  id: string | null;
  assistant_enabled: boolean;
  assistant_name: string;
  language: string;
  tone: string;
  business_context: string;
  services_context: string;
  pricing_context: string;
  faq_context: string;
  lead_capture_enabled: boolean;
  appointment_goal_enabled: boolean;
  whatsapp_handoff_enabled: boolean;
}

export const DEFAULT_AI_SETTINGS: AiSettings = {
  id: null,
  assistant_enabled: false,
  assistant_name: 'Sales Assistant',
  language: 'en',
  tone: 'professional',
  business_context: '',
  services_context: '',
  pricing_context: '',
  faq_context: '',
  lead_capture_enabled: true,
  appointment_goal_enabled: false,
  whatsapp_handoff_enabled: false,
};

export const LANGUAGES = [
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Spanish' },
  { value: 'pt', label: 'Portuguese (Brazil)' },
  { value: 'fr', label: 'French' },
  { value: 'de', label: 'German' },
  { value: 'it', label: 'Italian' },
  { value: 'nl', label: 'Dutch' },
  { value: 'pl', label: 'Polish' },
  { value: 'ja', label: 'Japanese' },
  { value: 'zh', label: 'Chinese (Simplified)' },
];

export const TONES = [
  {
    value: 'professional',
    label: 'Professional',
    desc: 'Formal, trustworthy, polished',
    icon: 'ri-briefcase-line',
  },
  {
    value: 'friendly',
    label: 'Friendly',
    desc: 'Warm, approachable, personable',
    icon: 'ri-heart-line',
  },
  {
    value: 'casual',
    label: 'Casual',
    desc: 'Relaxed, conversational, easy-going',
    icon: 'ri-chat-smile-line',
  },
  {
    value: 'elegant',
    label: 'Elegant',
    desc: 'Refined, luxurious, sophisticated',
    icon: 'ri-vip-crown-line',
  },
  {
    value: 'persuasive',
    label: 'Persuasive',
    desc: 'Sales-focused, compelling, action-driven',
    icon: 'ri-rocket-line',
  },
  {
    value: 'empathetic',
    label: 'Empathetic',
    desc: 'Understanding, supportive, caring',
    icon: 'ri-user-heart-line',
  },
];